export default __webpack_public_path__ + "images/cert-ul.png?0bb125ce54de074ebbb25450c3eee746";